var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Stepper',{attrs:{"stepperSteps":_vm.stepperSteps,"showNavigation":false,"detailsId:":"","detailsId":""},on:{"completed-step":_vm.completeStep,"active-step":_vm.isStepActive,"closeRefresh":_vm.closeRefresh}})
}
var staticRenderFns = []

export { render, staticRenderFns }